<template>
  <v-app>
    <v-container fluid class="fill-height pa-0" style="background: linear-gradient(135deg, #EFEBE9 0%, #D7CCC8 100%);">
      <v-row no-gutters class="fill-height" align="center" justify="center">
        <v-col cols="12" sm="10" md="8" lg="6" xl="5">
          <v-card class="elevation-12 rounded-xl ma-4" style="overflow: hidden;">
            <!-- Header with logo -->
            <v-card-title class="primary white--text pa-6 text-center">
              <div class="w-100">
                <v-img
                  :src="require('@/assets/logoHeader.png')"
                  max-width="150"
                  class="mx-auto mb-3"
                ></v-img>
                <h2 class="font-weight-light">Crear Cuenta</h2>
                <p class="mb-0 body-2">Regístrate en el Centro Médico Terrada</p>
              </div>
            </v-card-title>

            <v-card-text class="pa-6">
              <v-alert
                v-model="showWelcomeAlert"
                type="info"
                dismissible
                class="mb-4"
                border="left"
              >
                <div class="d-flex align-center">
                  <v-icon class="mr-2">mdi-information</v-icon>
                  <div>
                    <strong>¡Bienvenido!</strong>
                    <br>
                    Complete todos los campos para crear su cuenta y poder solicitar turnos médicos.
                  </div>
                </div>
              </v-alert>

              <!-- Componente Paciente envuelto en un diseño moderno -->
              <div class="patient-form-wrapper">
                <Paciente
                  :captcha="sendCaptcha"
                  @account_info_from_child="handlerDataSave"
                  class="modern-form"
                />
              </div>
            </v-card-text>

            <!-- Footer con enlace a login -->
            <v-card-actions class="pa-6 pt-0">
              <v-spacer></v-spacer>
              <div class="text-center w-100">
                <v-divider class="mb-4"></v-divider>
                <p class="body-2 grey--text mb-2">¿Ya tienes cuenta?</p>
                <v-btn
                  outlined
                  color="primary"
                  :to="'/login'"
                  class="rounded-lg"
                >
                  <v-icon left>mdi-login</v-icon>
                  Iniciar Sesión
                </v-btn>
              </div>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>

      <!-- Loading Dialog mejorado -->
      <v-dialog
        v-model="espereDialog"
        persistent
        width="350"
      >
        <v-card class="rounded-lg">
          <v-card-text class="text-center pa-6">
            <v-progress-circular
              indeterminate
              color="primary"
              size="64"
              class="mb-4"
            ></v-progress-circular>
            <h3 class="primary--text mb-2">Creando cuenta...</h3>
            <p class="body-2 grey--text mb-0">Por favor espere mientras procesamos su información</p>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </v-app>
</template>
<script>

//import axios from 'axios';

import { signup } from '@/services/auth';
import { loginConPerfil } from '@/services/auth';
import { getData } from '@/services/monolito';
//import {initial_data} from "@/services/utils"
import Paciente from "@/components/Paciente.vue"

export default {
    name: "SignUp",
    // Data
    data() {
        return {
            //site_key:"AIzaSyAlQ0Cw9Fbv7e3WHaLzVjbvSmNV8QPT3wc",
            account_id: "",
            account_info: {
                mail: "",
                gender:"",
                thalamus_server: this.$default_thalamus_server,
                name: "",
                lastname: "",
                password: "" ,
                dni:"",
                roles: ["end_user"],
                dob: "",
                active: true,
                deceased: false,
                street:"",
                subdivision:"",
                insuranse:  "",
                telefono:"",
                robot: false
            },
            account_info_local : {},
            // local variables not to be passed
            pass_confirm: "",
            mail_confirm: "",
            espereDialog: false,
            insuranseOptions: [],
            dialog:false,
            sendCaptcha: true,
            provincias: [],
            showWelcomeAlert: true
        }
    },
    created(){
        //this.getInitialData()
    },
    

    components: {
       //'vue-recaptcha': VueRecaptcha,
       Paciente
    },

    // Using Axios
    
    methods: {
        set_dialog(state){
                this.dialog = state
        },
        handlerDataSave: function (datos){

           this.espereDialog = true
           this.account_info = datos
           this.crearCuenta()
       },
        
        
        /*async getInitialData(){
            let data = await initial_data(this.$store.state.credentials.thalamus_server)
          
            this.insuranseOptions=data.insuranse
            this.provincias=data.provincias
        },*/
        
        async crearCuenta(){
            try {

                
                // Obtener email del formulario
                const email = this.account_info.email || this.account_info.mail;
                const password = this.account_info.password;
                
                if (!email || !password) {
                    throw new Error('Email y contraseña son requeridos');
                }
                
                // 1. Crear cuenta en Auth Services

                const authResponse = await signup({
                    username: email,
                    email: email,
                    password: password,
                    roles: ['patient']
                });

                
                // 2. Auto-login para obtener token

                await loginConPerfil({
                    username: email,
                    password: password
                }, this.$store);

                
                // Guardar datos parciales del perfil para pre-llenar CompletarPerfil
                const partialProfile = {
                    email: email,
                    name: this.account_info.name || '',
                    lastname: this.account_info.lastname || '',
                    dni: this.account_info.dni || '',
                    gender: this.account_info.gender || '',
                    dob: this.account_info.dob || '',
                    phone: this.account_info.telefono || this.account_info.phone || '',
                    insurance_id: this.account_info.insuranse || null
                };
                
                // Guardar en localStorage para que CompletarPerfil lo use
                localStorage.setItem('signup_partial_profile', JSON.stringify(partialProfile));

                
                this.espereDialog = false;
                this.set_dialog(false);
                
                // 3. Redirigir a CompletarPerfil

                this.$router.replace({ name: 'completar-perfil' });
                
            } catch (error) {
                console.error('SignUp - Error catch en crearCuenta:', error);
                this.espereDialog = false;
                this.set_dialog(false);
                
                // Manejar errores específicos
                let errorMessage = 'Error inesperado al crear la cuenta. Intente nuevamente.';
                let errorTitle = 'Error';
                
                if (error.response && error.response.status === 409) {
                    errorTitle = 'Usuario existente';
                    errorMessage = 'Ya existe una cuenta con este email. Por favor inicie sesión.';
                } else if (error.response && error.response.status === 400) {
                    errorMessage = error.response.data && error.response.data.detail ? error.response.data.detail : 'Datos inválidos. Por favor revise el formulario.';
                } else if (error.message) {
                    errorMessage = error.message;
                }
                
                this.$alert({ title: errorTitle, message: errorMessage, color: 'error' });
            }
        },

  /*validateCreateForm() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    if (this.account_info.robot){
                        this.crearCuenta();
                    }
                }
                else {
        this.$alert({ title: 'Validación', message: 'Por favor, revisar los datos ingresados', color: 'warning' });
                    this.set_dialog(false);
                }
            });
        },*/

    },
}
</script>

<style scoped>
.patient-form-wrapper {
  background-color: #fafafa;
  border-radius: 12px;
  padding: 20px;
  border: 1px solid #e0e0e0;
}

.modern-form {
  background: transparent;
}

/* Mejorar estilos de los campos del formulario */
.patient-form-wrapper >>> .v-text-field {
  margin-bottom: 8px;
}

.patient-form-wrapper >>> .v-text-field .v-input__control .v-input__slot {
  border-radius: 8px !important;
}

.patient-form-wrapper >>> .v-btn {
  text-transform: none !important;
  border-radius: 8px !important;
  font-weight: 500;
}

.patient-form-wrapper >>> .v-select {
  margin-bottom: 8px;
}

/* Estilos para el contenedor principal */
.fill-height {
  min-height: 100vh;
}

/* Efectos de hover para botones */
.v-btn:hover {
  transform: translateY(-1px);
  transition: all 0.3s ease;
}

/* Responsividad */
@media (max-width: 600px) {
  .v-card {
    margin: 8px !important;
  }
  
  .patient-form-wrapper {
    padding: 16px;
  }
}
</style>

<style>
  #nota{
    font-size: 80%;
    color: #dc3545;
  }
  .style-select .vs__search::placeholder,
  .style-select .vs__search,
  .style-select .vs__dropdown-menu {
    border: none;
    text-transform: lowercase;
    font-variant: small-caps;
  }
  .vs__fade-enter-active,
  .vs__fade-leave-active {
        transition: none;
    }
  .invalid-feedback {
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #dc3545;
    }
</style>
